const isNullOrFalse = value => value === null || value === false;

module.exports = isNullOrFalse;
